export class ResponseMovements {

  undoApertura: boolean;
  apertura: boolean;
  noApertura: boolean;

  regularizacion: boolean;
  undoRegularizacion: boolean;

  cierre: boolean;
  undoCierre: boolean;

  constructor() {
  }
}

export class ExpensePDF{
  invoiceNumber: string;
  issuerName: string;
}
